export default __webpack_public_path__ + "static/media/3WF.1fab521d.png";